// extracted by mini-css-extract-plugin
export default {"root":"BusinessSelector_root__vpgsu","select":"BusinessSelector_select__yfFgg"};